import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import ConnectWallet from "../components/ConnectWallet";
import {
  setIsLoggedIn,
  setToken,
  setUserInfo,
  setWalletAddress,
} from "../Redux/WallatSlice";
import { loginUserApi } from "../utils/apiHandlers";
import toast from "react-hot-toast";
import { useAccount, useSignMessage } from "wagmi";
const ADMINWALLET = process.env.REACT_APP_ADMIN_WALLET;

function Login() {
  const { isConnected, address } = useAccount();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("address");
  const dispatch = useDispatch();
  const { signMessageAsync } = useSignMessage(); // Use signMessageAsync instead of signMessage

  const handleSignMessage = async () => {
    try {
      // const msg = "login to blockagent" + address;
      // const signature = await signMessageAsync({
      //   message: msg,
      // });
      handleLogin();
    } catch (error) {
      console.error("Signing failed:", error);
    }
  };

  function updateLoginState(respData) {
    console.log(respData);
    dispatch(setIsLoggedIn(true));
    dispatch(setToken(respData?.token)); // setting jwt token to localstorage
    dispatch(setUserInfo(respData?.userinfo)); // setting userinfo data to redux
  }

  async function handleLogin(signature, message) {
    try {
      if (!isConnected) {
        toast.error("Please connect wallet");
        return;
      }
      const loginresp = loginUserApi({ address });
      const ress = await toast.promise(loginresp, {
        loading: "verifying user, please wait...",
        success: () => {},
        error: "login failed",
      });
      if (ress?.message && ress?.status != 200) {
        toast.error(ress?.message);
      } else {
        if (ress?.userinfo?.user != address?.toLowerCase()) {
          toast.error("Please connect registered wallet");
          setTimeout(() => {
            toast.error("Registered Wallet Address:: " + ress?.userinfo?.user);
          }, 300);
          return;
        }
        if (ress?.status == 200) {
          toast.success(ress?.message);
          updateLoginState(ress);
        }
      }
    } catch (e) {
      console.log(e, "loginerror");
    }
  }

  useEffect(() => {
    if (isConnected && address) {
      dispatch(setWalletAddress(address));
    }
  }, [isConnected, address]);

  useEffect(() => {
    const handelAdminLogin = async () => {
      try {
        const loginresp = loginUserApi({ address: userId });
        const ress = await toast.promise(loginresp, {
          loading: "verifying user, please wait...",
          success: () => {},
          error: "login failed",
        });
        if (ress?.message && ress?.status != 200) {
          toast.error(ress?.message);
        } else {
          console.log(address, "ress");
          if (address != ADMINWALLET) {
            toast.error("Please connect admin wallet");
            return;
          } 
          if (ress?.status == 200) {
            toast.success(ress?.message);
            updateLoginState(ress);
          }
        }
      } catch (e) {
        console.log(e, "loginerror");
      }
    };
    if (userId && address) {
      handelAdminLogin(userId);
    }
  }, [userId, address]);
  
  return (
    <>
      <div class="bodybg">
        <div
          class="page-wrapper"
          id="main-wrapper"
          data-layout="vertical"
          data-navbarbg="skin6"
          data-sidebartype="full"
          data-sidebar-position="fixed"
          data-header-position="fixed"
        >
          <div class="position-relative overflow-hidden  min-vh-100 d-flex align-items-center justify-content-center">
            <div class="d-flex align-items-center justify-content-center w-100">
              <div class="row justify-content-center w-100">
                <div class="col-md-8 col-lg-6 col-xxl-3">
                  <div class="card mb-0 cardbg">
                    <div class="card-body">
                      <a
                        href="#"
                        class="text-nowrap logo-img text-center d-block mb-5 w-100 "
                      >
                        <img
                          src={require("../assets/logoWithName2.png")}
                          width="280"
                          alt=""
                          className=""
                        />
                      </a>

                      <div class="position-relative text-center my-4">
                        <h2 class="mb-3 fs-7 fw-bolder">Login Now</h2>
                      </div>

                      <div class="mb-3">
                        <p>
                          <ConnectWallet />
                        </p>
                      </div>

                      <div class="mb-3">
                        <label for="user-email" class="form-label">
                          Wallet Address
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="user-email"
                          name="user-email"
                          value={address}
                          autoComplete="off"
                          placeholder="wallet address"
                          readOnly
                        />
                      </div>

                      <button
                        class="btn btn-primary w-100 py-8 mb-4 rounded-2 registra mybtncolor"
                        onClick={handleSignMessage}
                      >
                        Submit
                      </button>
                      <div class="d-flex align-items-center">
                        <p class="fs-4 mb-0 text-dark">
                          Register First then login ?
                        </p>
                        <Link
                          class="text-primary fw-medium ms-2"
                          to="/register"
                        >
                          Register
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
